
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomatherancabs() {



    const cardData =
    {
        keyword: ' Pune to Matheran Cab',
        heading: 'Prince Cabs: Pune to Matheran Cab',
        headingDescription: 'Prince Cabs offers dependable Pune to Matheran Cab services, perfect for weekend getaways, family vacations, corporate trips, and leisure travel. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride to Matheran, a scenic hill station famous for its viewpoints, greenery, and toy train rides. With professional chauffeurs, on-time pickups, and flexible schedules, we make your Pune to Matheran journey smooth and stress-free. Enjoy affordability, reliability, and convenience with Prince Cabs’ trusted cab service from Pune to Matheran.',

        top: 'Top Places to Visit in Matheran with Prince Cabs',

"topPlaces": [
  {
    "title": "Panorama Point",
    "description": "Panorama Point is one of the most popular viewpoints in Matheran, offering a 360-degree view of the surrounding Sahyadri ranges. Visitors enjoy breathtaking sunrises and sunsets from this spot. The vast valleys and misty hills make it a favorite for photographers. The trek to reach the point is adventurous yet rewarding. During monsoon, the lush greenery and waterfalls add to the charm. It truly justifies its name by providing panoramic landscapes."
  },
  {
    "title": "Echo Point",
    "description": "Echo Point is famous for its natural echo phenomenon, where voices bounce back from the surrounding hills. It is a fun spot for families, especially kids who enjoy shouting and hearing the echo. The viewpoint also offers scenic vistas of valleys and forests. Monsoon adds waterfalls and mist, making it even more appealing. Visitors often combine this with nearby Charlotte Lake. It is both an entertaining and scenic attraction."
  },
  {
    "title": "Charlotte Lake",
    "description": "Charlotte Lake is a serene waterbody that serves as the main source of drinking water for Matheran. Surrounded by dense forests, it is a peaceful spot ideal for nature lovers. Birdwatchers often spot a variety of species here. The lake overflows into a small waterfall during monsoon, enhancing its beauty. The nearby Pisarnath Temple adds spiritual significance. It is perfect for quiet walks and picnics."
  },
  {
    "title": "Louisa Point",
    "description": "Louisa Point is a spectacular viewpoint that offers both valley and waterfall views. Visitors enjoy breathtaking vistas of Prabal Fort and Vishalgad Fort in the distance. It is especially popular during monsoon when waterfalls gush through the valleys. The spot is great for photography and sightseeing. The cool breeze and peaceful ambiance make it a favorite among tourists. It is one of Matheran’s must-visit attractions."
  },
  {
    "title": "One Tree Hill Point",
    "description": "One Tree Hill Point is unique as it features a lone tree standing tall at the peak. The location offers stunning views of the Western Ghats and surrounding valleys. Trekkers often enjoy the adventurous climb to the top. The monsoon season makes the trail more exciting with streams and greenery. The isolated tree against the vast landscape creates a striking image. It is a popular choice for photographers and trekkers."
  },
  {
    "title": "Porcupine Point (Sunset Point)",
    "description": "Porcupine Point, also known as Sunset Point, is the best place to witness Matheran’s glowing evening skies. The spot offers views of deep valleys and surrounding mountains. Tourists gather here to watch the sun dip behind the hills. The silhouette of the landscape during sunset is magical. Monsoon clouds add dramatic effects to the view. It is one of the most romantic and memorable spots in Matheran."
  },
  {
    "title": "Monkey Point",
    "description": "Monkey Point is known for its large population of playful monkeys that entertain tourists. Visitors also enjoy stunning valley views from this spot. The point is easily accessible and often crowded with families. The mischievous monkeys are both fun and fascinating to watch. Tourists are advised to be cautious with food items. It is a lively attraction blending nature and wildlife."
  },
  {
    "title": "Alexander Point",
    "description": "Alexander Point offers panoramic views of Palasdari Lake, Rambaug Point, and Garbut Point. It is a less-crowded spot, making it ideal for peace seekers. Trekkers enjoy hiking to this location for the refreshing breeze and greenery. The point provides excellent photography opportunities with wide valley backdrops. During monsoon, it becomes especially scenic with mist and waterfalls. It is perfect for those who prefer offbeat attractions."
  },
  {
    "title": "Toy Train (Neral–Matheran Railway)",
    "description": "The Neral–Matheran Toy Train is a UNESCO World Heritage site and one of the main highlights of Matheran. The narrow-gauge railway passes through lush hills, forests, and scenic curves. The journey offers breathtaking views of the Western Ghats. Built in 1907, it remains a nostalgic experience for travelers. The train ride is especially enjoyable during monsoon and winter. It is a must-do activity when visiting Matheran."
  },
  {
    "title": "Market Road",
    "description": "Matheran’s Market Road is the central hub for shopping and local experiences. Visitors can buy leather goods, handicrafts, and locally made chikkis. The market is lively with small eateries serving Maharashtrian snacks and beverages. Since Matheran is vehicle-free, exploring the market on foot or horseback is enjoyable. Evenings here are vibrant with tourists and locals alike. It is the best place to experience Matheran’s culture and flavors."
  }
],


"services": [
    {
        "name": "Pune to Matheran Cab",
        "description": "Reliable and comfortable cab services from Pune to Matheran, offering timely pickups and professional drivers who ensure a safe and pleasant journey. Perfect for tourists and locals alike, enjoy scenic routes with well-maintained vehicles and hassle-free booking."
    },
    {
        "name": "Pune to Matheran Cab Fare",
        "description": "Transparent and affordable cab fare options for your trip from Pune to Matheran. Our pricing is competitive with no hidden costs, giving you value for money. Choose from various vehicle types to suit your travel preferences and budget."
    },
    {
        "name": "Pune to Matheran Taxi Fare",
        "description": "Get clear and upfront taxi fare details for Pune to Matheran rides. Whether you want a one-way trip or round trip, we provide economical rates without compromising on comfort or service quality, ensuring a smooth travel experience."
    },
    {
        "name": "Pune to Matheran Cab Booking",
        "description": "Easily book your cab from Pune to Matheran with our seamless online booking system. Choose your preferred vehicle, schedule your trip, and get instant confirmation. Our customer support ensures all your queries are answered promptly."
    },
    {
        "name": "Pune to Matheran Taxi",
        "description": "Enjoy dependable taxi service from Pune to Matheran with experienced drivers who know the best routes to avoid traffic and ensure on-time arrival. Our taxis are clean, comfortable, and perfect for solo travelers, families, and groups."
    },
    {
        "name": "Pune to Matheran Innova Taxi Fare",
        "description": "Book a spacious and comfortable Innova taxi from Pune to Matheran at affordable fares. Ideal for families and groups, the Innova offers ample space for passengers and luggage, along with a smooth ride and courteous drivers."
    },
    {
        "name": "Pune to Matheran Package",
        "description": "Explore customizable tour packages from Pune to Matheran that include cab service, sightseeing stops, and flexible itineraries. Perfect for tourists looking to enjoy the hill station at their own pace with reliable transportation."
    },
    {
        "name": "Pune to Matheran Dzire Cab",
        "description": "Travel in style and comfort with our Dzire cab service from Pune to Matheran. This sedan is perfect for small families and couples, offering a smooth, air-conditioned ride and professional driving service."
    },
    {
        "name": "Pune to Matheran Round Trip Taxi",
        "description": "Plan your round trip from Pune to Matheran with our dedicated taxi service. Enjoy flexible schedules, comfortable vehicles, and courteous drivers, making your return journey just as hassle-free as your onward trip."
    },
    {
        "name": "Pune to Matheran Family Cab",
        "description": "Travel comfortably with your family in our spacious cabs from Pune to Matheran. With enough room for passengers and luggage, our family cabs ensure a safe, stress-free journey for all members, complete with experienced drivers."
    },
    {
        "name": "Pune to Matheran Affordable Taxi",
        "description": "Affordable and reliable taxi services from Pune to Matheran for budget-conscious travelers. We provide quality vehicles and professional drivers at reasonable prices, ensuring you get the best value without compromising on comfort or safety."
    }
],
"tableData": [
    ["Pune to Matheran Cab", "Pune to Matheran Cab Fare"],
    ["Pune to Matheran Taxi Fare", "Pune to Matheran Cab Booking"],
    ["Pune to Matheran Taxi", "Pune to Matheran Innova Taxi Fare"],
    ["Pune to Matheran Package", "Pune to Matheran Dzire Cab"],
    ["Pune to Matheran Round Trip Taxi", "Pune to Matheran Family Cab"],
    ["Pune to Matheran Affordable Taxi", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Matheran Cab Service",
        "WhyChoosedescription": "Prince Cabs provides a dependable and comfortable taxi service from Pune to Matheran, ideal for leisure travelers, families, and nature lovers. Whether you're visiting Matheran’s famous viewpoints, serene lakes, or enjoying its vehicle-free environment, we ensure a smooth and timely journey to this picturesque hill station."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes spacious, air-conditioned sedans and SUVs, meticulously maintained for comfort and safety. With ample legroom and clean interiors, our vehicles make the roughly 120 km journey enjoyable, allowing you to relax and soak in the scenic drive through the Western Ghats."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
        "WhyChoosedescription": "Our professional drivers are well-versed with the Pune to Matheran route, including the best ways to avoid traffic and the safest routes to reach the hill station. They prioritize your safety and comfort, providing courteous service and helpful information about the region."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Fit Your Travel Needs",
        "WhyChoosedescription": "Whether you need a one-way transfer, a round trip, or a full-day rental to explore Matheran and its surroundings, Prince Cabs offers customizable packages to match your itinerary. Booking is simple via phone, website, or WhatsApp with quick confirmations and easy rescheduling."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Protocols",
        "WhyChoosedescription": "We ensure all vehicles are thoroughly sanitized before and after each trip. Regular maintenance and safety checks, including seat belts, GPS tracking, and first-aid kits, guarantee a secure and healthy travel experience for you and your companions."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Payment Methods",
        "WhyChoosedescription": "Prince Cabs provides upfront, competitive pricing without hidden charges. We accept payments via UPI, credit/debit cards, net banking, and cash, making your booking and payment hassle-free and secure."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Experience",
        "WhyChoosedescription": "Our dedicated customer support team is available round the clock to assist with bookings, cancellations, and travel inquiries. We strive to ensure your Pune to Matheran cab journey is seamless, convenient, and enjoyable from start to finish."
    }
]
























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Matheran cab services?',
        answer: 'Yes, Prince Cabs provides reliable and comfortable cab services from Pune to Matheran, ideal for weekend getaways and nature retreats.',
    },
    {
        question: 'Can cabs go directly to Matheran from Pune?',
        answer: 'Private vehicles are not allowed beyond Dasturi Naka near Matheran. Our cab will drop you at Dasturi Naka, from where you can proceed by foot, horse, or toy train.',
    },
    {
        question: 'What types of cabs are available for Pune to Matheran travel?',
        answer: 'We offer hatchbacks, sedans, SUVs, and tempo travellers to suit solo travelers, couples, families, and groups of all sizes.',
    },
    {
        question: 'Do you offer one-way and round-trip cabs to Matheran?',
        answer: 'Yes, we offer flexible booking options including one-way, round-trip, and same-day return cabs from Pune to Matheran.',
    },
    {
        question: 'What are the charges for a Pune to Matheran cab?',
        answer: 'Cab charges depend on the vehicle type, trip duration, and specific requirements. Contact Prince Cabs for a personalized and competitive quote.',
    },
    {
        question: 'How do I book a Pune to Matheran cab with Prince Cabs?',
        answer: 'You can book your cab easily through our website or by calling our customer support. Just share your travel details and we’ll take care of the rest.',
    },
    {
        question: 'Are your cabs clean and safe for hilly routes like Matheran?',
        answer: 'Yes, all our cabs are well-maintained and sanitized. Our experienced drivers are familiar with the Matheran route and ensure a safe journey.',
    },
];

const testimonials = [
    {
        name: "Mr. Kiran Jadhav",
        position: "Nature Enthusiast",
        text: "Prince Cabs made our Pune to Matheran trip really convenient. The driver dropped us right at Dasturi Naka and guided us on how to proceed to Matheran.",
        image: "/img/testimonial/testimonial-thumb-matheran-1.png",
    },
    {
        name: "Mrs. Vaishali Deshpande",
        position: "Family Traveler",
        text: "Very satisfied with the service. Clean cab, smooth ride, and the driver was helpful. Will definitely use Prince Cabs for our next hill station trip.",
        image: "/img/testimonial/testimonial-thumb-matheran-2.png",
    },
];

































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Matheran Cab",
  "image": "https://princecab.com/assets/images/pune-matheran-cab.jpg",
  "description": "Book Pune to Matheran cab service with Prince Cabs. Affordable and reliable taxi options including Innova, Dzire, and family cabs. Perfect for round trips and package tours. 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-matheran-cab"
  }
};



    return (
        <div>
<Helmet>
  <title>Pune to Matheran Cab | Affordable & Reliable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Matheran cab service with Innova, Dzire, and family cabs. Affordable fares for round trips and package tours. Book your taxi online 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Matheran Cab, Pune to Matheran Cab Fare, Pune to Matheran Taxi Fare, Pune to Matheran Cab Booking, Pune to Matheran Taxi, Pune to Matheran Innova Taxi Fare, Pune to Matheran Package, Pune to Matheran Dzire Cab, Pune to Matheran Round Trip Taxi, Pune to Matheran Family Cab, Pune to Matheran Affordable Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/23.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomatherancabs;